// UI Version Resolver - reads env var + query param
export const getUiVersion = () => {
  // Query param override takes priority
  const params = new URLSearchParams(window.location.search);
  const queryVersion = params.get('ui');
  if (queryVersion === 'v2' || queryVersion === 'v1') return queryVersion;
  
  // Check CRA env var
  if (process.env.REACT_APP_UI_VERSION === 'v1') return 'v1';
  
  return 'v2'; // Default is now V2
};

export const isV2 = () => getUiVersion() === 'v2';
